import React from 'react';
import { NavLink } from 'react-router-dom';

import { getImageFullPath } from '../../core';
import DOMPurify from 'dompurify';

const CardBlog = (props) => {
  // const [newsData, setNewsData] = useState(props.data);

  function removeEmptyPTags(html) {
    // Use a DOM parser to remove empty <p> tags
    const safeHtml = typeof html === 'string' ? html : '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(safeHtml, 'text/html');
    const paragraphs = doc.querySelectorAll('p');

    paragraphs.forEach((p) => {
      if (!p.textContent.trim()) {
        p.remove(); // Remove empty <p> tags
      }
    });

    return doc.body.innerHTML;
  }

  function normalizeParagraphs(html) {
    const safeHtml = typeof html === 'string' ? html : '';
    // Replace paragraph tags with divs to avoid UA paragraph spacing/justify
    return safeHtml.replace(/<p[^>]*>/gi, '<div>').replace(/<\/p>/gi, '</div>');
  }

  function extractFirstIframeHtml(html) {
    const safeHtml = typeof html === 'string' ? html : '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(safeHtml, 'text/html');
    const iframe = doc.querySelector('iframe');
    if (!iframe) return null;

    // Enforce full-width iframe while preserving other attributes
    const existingStyle = iframe.getAttribute('style') || '';
    const enforcedStyle = 'width:100%;max-width:100%;';
    iframe.setAttribute(
      'style',
      existingStyle ? `${existingStyle}; ${enforcedStyle}` : enforcedStyle
    );

    return iframe.outerHTML;
  }

  const rawDesc = props?.data?.desc || '';
  const sanitizedDescription = normalizeParagraphs(removeEmptyPTags(rawDesc));
  const iframeHtml = extractFirstIframeHtml(rawDesc);

  // Sanitize while allowing iframe-related attributes when needed
  const sanitizerOptions = {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'frameborder',
      'scrolling',
      'src',
      'title',
      'width',
      'height',
      'style',
    ],
  };

  const sanitizedIframe = iframeHtml
    ? DOMPurify.sanitize(iframeHtml, sanitizerOptions)
    : null;

  const sanitizedDescForRender = DOMPurify.sanitize(sanitizedDescription, {
    ...sanitizerOptions,
    FORBID_ATTR: ['style', 'align'], // strip inline justification
  });

  return (
    <NavLink
      to={`/news/detail/${props.data.id}`}
      className='wrapper__card-blog color__black d-inline-block w-100'
    >
      <img
        src={getImageFullPath(`uploads/news/${props.data.img}`)}
        className='img'
        alt=''
      />
      <div className='desc'>
        <div className='d-flex align-items-center mb-2'>
          <h5 className='mb-0 semi-bold font__size--14 text__14-1024 text-uppercase color__gray-1'>
            {props.data.date}
          </h5>
        </div>
        <div className='mb-2 bold font__size--18 text__20-1024 text-uppercase clamp__2 '>
          {props.data.title}
        </div>
        {sanitizedIframe ? (
          <div
            className='video-wrapper'
            dangerouslySetInnerHTML={{ __html: sanitizedIframe }}
          />
        ) : (
          <div
            className='normal font__size--15 text__16-1024 clamp__3'
            dangerouslySetInnerHTML={{ __html: sanitizedDescForRender }}
          />
        )}
        <div className='d-inline-block mt-2'>
          <span className='color__blue text-uppercase text__15-1024 font__size--15'>
            იხილეთ სრულად
          </span>
        </div>
      </div>
    </NavLink>
  );
};

export default CardBlog;
